import { FC } from 'react';
import { CommomGeneralQuestionsForm } from 'components/RadabankCard/CommonGeneralQuestionsForm';

export const OverdraftGeneralQuestionsStep: FC = () => {
	return <CommomGeneralQuestionsForm />;
};
